import { Skeleton, Stack } from "@mui/material";
import { Box } from "@mui/material";

const BidsVisualizationSkeleton = ({ height }: { height: number }) => {
  return (
    <Box sx={{ width: "100%", height }}>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" width="100%" mb={3} mt={1}>
        <Skeleton variant="text" width="130px" />
        <Skeleton variant="text" width="130px" />
      </Stack>

      <Skeleton variant="rounded" width="100%" height={height - 150} sx={{ mb: 1 }} />

      <Skeleton variant="rounded" width="100%" height={80} sx={{ mb: 2 }} />
    </Box>
  );
};

export default BidsVisualizationSkeleton;
